import { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { isMobile } from 'react-device-detect'

export default function Dropdown({
  data,
  setReceiverMemo,
  value,
}: {
  data: Array<string>
  setReceiverMemo: (v: string) => void
  value?: string
}) {
  const [isSelectFocus, setIsSelectFocus] = useState<boolean>(false)

  // value가 undefined일 때만 초기값 세팅
  useEffect(() => {
    if (value === undefined && data[0]) setReceiverMemo(data[0])
  }, [value, data, setReceiverMemo])

  return (
    <DropdownWrap>
      <DropdownSelect
        value={value}
        defaultValue={value === undefined ? data[0] : undefined}
        $isFocus={isSelectFocus}
        $isMobile={isMobile}
        onChange={(e: any) => {
          setReceiverMemo(e.target.value)
          setIsSelectFocus(false)
        }}
        onFocus={() => setIsSelectFocus(true)}
        onBlur={() => setIsSelectFocus(false)}
      >
        {data.map((el, index) => (
          <option key={index} value={el}>
            {el}
          </option>
        ))}
      </DropdownSelect>
      <DropdownArrow src='/images/icon_arrow_down.png' alt='dropdownarrow' $isMobile={isMobile} />
    </DropdownWrap>
  )
}

const DropdownWrap = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
`

const DropdownSelect = styled.select<{ $isFocus: boolean; $isMobile: boolean }>`
  ${({ $isMobile, $isFocus }) =>
    $isMobile
      ? css`
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          color: var(--colBlack);
          padding: 10px 0 10px 14px;
          width: 100%;
          border-radius: 5px;
          border: ${$isFocus ? '1px solid var(--colBlack)' : '1px solid var(--colGray3)'};
          background-color: var(--colWhite);
          box-sizing: border-box;
          appearance: none;
          -webkit-appearance: none;
        `
      : css`
          font-size: 15px;
          font-weight: 500;
          line-height: 20px;
          color: var(--colBlack);
          padding: 10px 38px 10px 16px;
          width: 100%;
          border-radius: 5px;
          border: ${$isFocus ? '1px solid var(--colBlack)' : '1px solid var(--colGray3)'};
          background-color: var(--colWhite);
          box-sizing: border-box;
          appearance: none;
          -webkit-appearance: none;
        `}
`

const DropdownArrow = styled.img<{ $isMobile: boolean }>`
  width: 16px;
  height: 16px;
  position: absolute;
  right: ${({ $isMobile }) => ($isMobile ? '12px' : '14px')};
  top: 50%;
  transform: translateY(-50%);
  background-color: white;
  pointer-events: none;
`
